/* eslint-disable react/prop-types */
import React from 'react';
import { Box } from '@mui/material';

export default function PaymentIframe({ iframeUrl }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <iframe
        src={iframeUrl}
        title="Kashier Payment"
        width="100%"
        height="500"
        style={{ border: '1px solid #ccc', borderRadius: '8px' }}
      />
    </Box>
  );
}
